import { createAsyncThunk } from '@reduxjs/toolkit';

import { FetchLastGameDataParams, fetchLastGameData } from '../../api/lastGameData/fetcher';

export const fetchLastGameDataAction = createAsyncThunk(
	'recentResults/fetchLastGameDataAction',
	(params: FetchLastGameDataParams) => fetchLastGameData(params)
);
